import imageService from '@/services/imageService'
import errorService from '@/services/errorService'

import {getByUser, getById, getByCollective, getByProject, getByVoted} from '@/functions/filters.js'
import {mergeUniquely} from '@/functions/objects.js'

// import { delete } from 'vue/types/umd';

const state = {
  images: [],
  loading: false,
  last_updated: {},
  progress: 0,
  last_uploaded: 0
}
   
const getters = {
    filteredByAll: (state) => {
        return state.images
    },
    filteredByUser: (state) => (user) => {
      return getByUser(state.images, user)
    },
    filteredByCollective: (state) => (collective) => {
      return getByCollective(state.images, collective)
    },
    filteredByProject: (state) => (project) => {
      return getByProject(state.images, project)
    },
    filteredByVoted: (state) => {
      return getByVoted(state.images)
    },
    filteredById: (state) => (id) => {
      return getById(state.images, id)[0]
    },
    getLastUpdatedByPath: (state) => (path, sorting) => {
      if (path in state.last_updated) {
        let page_path = state.last_updated[path]
        if(sorting in page_path) {
          return page_path[sorting]
        }  
      }
    },
    getProgress: (state) => {
      return state.progress
    },
}

const actions = {
  getImages ({ commit, getters }, params ) {
    let path = params.route
    let sorting = params.sorting
    let last_updated = getters.getLastUpdatedByPath(path, sorting)
    if(last_updated) params.last_updated = last_updated
    delete(params.route)
    imageService.fetchImages( params )
    .then(results => {
        commit('setImages', {results, path, sorting})
        this.dispatch('user/setLastUpdated', results.last_updated, {root:true})
    })
  },
  
  voteImage({ commit }, image) {
    imageService.voteImage(image)
    .then(response => {
      if(response.image) {
        commit('voteImage', response.image)
      } else {
        this.dispatch('alert/setError', errorService.getErrorMessage(response), {root:true})
      }
    })
  },

  updateImage({ commit }, image) {
    imageService.updateImage(image.pk, image)
    .then(response => {
      if(response) {
        commit('updateImage', response)
      } else {
        this.dispatch('alert/setError', errorService.getErrorMessage(response), {root:true})
      }
    }).finally(() => {   
        this.dispatch('alert/setSuccess','Image updated succesfully', {root:true})
    })
  },

  uploadFile({ commit, dispatch }, file) {
      commit('startLoading')
      imageService.uploadImage(file, (event) => {
        commit('updateProgress', Math.round((100 * event.loaded) / event.total))
      })
      .then(response => { 
        commit('addImage', response)
        commit('setLastUploaded', response.pk)
      })
      .then(() => dispatch('getImages', {}))
      .finally(() => {   
        this.dispatch('alert/setSuccess','Image uploaded succesfully', {root:true})
    })

 
  },

  setProgress({commit}, progress) {
    commit('updateProgress', progress)
  }

}

const mutations = {

  addImage (state, response) {
    state.images.push(response)
  },
  
  setImages (state, response) {
    
    state.images = mergeUniquely(response.results.data, state.images, 'pk')
    if (response.path in state.last_updated) {
      state.last_updated[response.path][response.sorting] = response.results.last_updated
    } else {
      state.last_updated[response.path] = {}
      state.last_updated[response.path][response.sorting] = response.results.last_updated
    }
    // console.log(state.last_updated)
  },

  voteImage (state, image) {
    const entry = state.images.find(entry => entry.pk === image)
    Object.assign(entry.votes_count++)
    Object.assign(entry.voted=true)
  },

  updateImage (state, image) {
    state.images = mergeUniquely([image], state.images, 'pk')
    return true
  },

  startLoading (state) {
    state.loading = true
  },

  stopLoading (state) {
    state.loading = false
    state.progress = 0
  },

  updateProgress (state, progress) {
    state.progress = progress
  },

  setLastUploaded (state, pk) {
    state.last_uploaded = pk
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}